module.exports = __webpack_public_path__ + "images/dashboard-operation-logs@2x-65dad16c281e4e106fda23af8215eb06.png";